import MapImplementation from './implementation/MapImplementation';
var MapComponent = MapImplementation;
export default MapComponent;
//# sourceMappingURL=MapComponent.js.map